import { ca } from '@cian/analytics';

import { TAnalyticsOfferStatus } from '../../../../../../../types/analytics';
import { ITrackingPackageInfo } from './types';

interface ITrackParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  form_id: number | null | undefined;
  vas: string | null | undefined;
  siteType: 'desktop' | 'mobile';
}

interface IRecommendedPackageTrackParams extends ITrackParams {
  packageInfo: ITrackingPackageInfo;
}

interface IRecommendedPackagesTrackParams extends ITrackParams {
  packagesInfo: ITrackingPackageInfo[];
}

export const trackDefaultPublicationClick = (params: ITrackParams) => {
  const { analyticsOfferStatus, form_id, vas, siteType } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_click_sopr',
    label: 'announcement',
    page: {
      siteType,
      extra: {
        package_block_default_value: 'announcement',
        form_id,
        vas,
      },
    },
  });
};

export const trackRecommendedPackageClick = (params: IRecommendedPackageTrackParams) => {
  const { analyticsOfferStatus, form_id, vas, packageInfo, siteType } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_click_sopr',
    label: 'package',
    page: {
      siteType,
      extra: {
        package_info: packageInfo,
        package_block_default_value: 'announcement',
        form_id,
        vas,
      },
    },
  });
};

export const trackShowRecommendedPackagesWidget = (params: IRecommendedPackagesTrackParams) => {
  const { analyticsOfferStatus, form_id, vas, packagesInfo, siteType } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show_sopr',
    label: 'package',
    page: {
      siteType,
      extra: {
        package_info: packagesInfo,
        package_block_default_value: 'announcement',
        form_id,
        vas,
      },
    },
  });
};
